<template>
  <div class="breadcrumb">
    <!-- <img
      src="../../assets/Navigation1.png"
      style="margin-right: 10px; margin-top: -4px; width: 24px; height: 24px"
      alt=""
    /> -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in dataList"
        :key="index"
        :to="index == dataList.length - 1 ? { path: item.path } : ''"
      >
        <span :class="index == dataList.length - 1 ? 'color1' : 'color2'">{{
          item.label
        }}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="son">
        {{ son }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [],
      son: "",
    };
  },
  mounted() {},
  watch: {
    $route() {
      this.childrenSon();
    },
  },
  methods: {
    init(data) {
      this.dataList = [];
      this.dataList.push({
        label: data.label,
        path: data.path,
      });
      if (Object.prototype.hasOwnProperty.call(data, "children")) {
        this.DataLoop(data.children);
      }
    },
    DataLoop(data) {
      this.dataList.push({
        label: data.label,
        path: data.path,
      });
      if (Object.prototype.hasOwnProperty.call(data, "children")) {
        this.DataLoop(data.children);
      }
    },
    childrenSon() {
      setTimeout(() => {
        const lastItem = this.dataList[this.dataList.length - 1];
        if (lastItem.path !== this.$route.path) {
          this.son = this.$route.name;
        } else {
          this.son = null;
        }
      }, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.breadcrumb {
  margin: 20px 15% 0px 15%;
  width: 69%;
  height: 10px;
  padding: 20px 0 20px 1%;
  background: rgba(255, 255, 255, 0.65);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: left;
}
.color1 {
  color: red;
  font-weight: 700;
}
</style>